const isPromise = (p) => p && Object.prototype.toString.call(p) === '[object Promise]';

export default isPromise;
